import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { type OpalApiComponent } from '@opallabs/api'
import { EMPTY_TO_ONE, linkageFromResource } from '@opallabs/json-api'
import { safeDate } from '@opallabs/testing/src/dates'
import { boardResourceFactory } from './board'

type BoardObjectResourceV3 = OpalApiComponent<'V3', 'board_object'>
export const boardObjectResourceFactory: Factory<BoardObjectResourceV3> =
  Factory.define<BoardObjectResourceV3>(({ sequence }) => {
    return {
      id: uuidV4(),
      type: 'board_object',
      attributes: {
        created_at: safeDate.toISOString(),
        position: sequence,
        updated_at: safeDate.toISOString(),
      },
      relationships: {
        board: linkageFromResource(boardResourceFactory.build()),
        board_object_collection: EMPTY_TO_ONE,
        moment: EMPTY_TO_ONE,
        rich_text_document: EMPTY_TO_ONE,
      },
    } satisfies BoardObjectResourceV3
  })
